import React from "react";
import { Stack } from "@mui/material";
import "../../styles/ListingPageFilter.css";
import { ReactComponent as NoData } from "../../assets/logos/no-data.svg";

const NoDataFound = () => {
  return (
    <>
      <Stack sx={{ alignItems: "center" }} spacing={2}>
        <NoData />
        <h1>No Results Found</h1>
        <span className="no-data-span">
          We couldn`t find what you searched for try searching again
        </span>
      </Stack>
    </>
  );
};

export default React.memo(NoDataFound);
